import { GameState } from './GameState';
import { EconomyEngine } from './EconomyEngine';
import { EventBus } from './EventBus';
import { QuestEngine } from './QuestEngine';
import type { MiniGameId } from '../types';

export const MiniGameRunner = {
  rewardFor(score: number): { coins: number; stars: number } {
    return { coins: score * 4, stars: Math.floor(score / 10) };
  },

  reportResult(
    minigameId: MiniGameId,
    score: number,
    fromX?: number,
    fromY?: number,
  ): { coins: number; stars: number } {
    const prev = GameState.data.stats.minigameBest[minigameId] ?? 0;
    if (score > prev) GameState.data.stats.minigameBest[minigameId] = score;

    // 누적 플레이 카운터 증가 + 퀘스트 진행도 갱신
    GameState.data.stats.minigamesPlayCount = (GameState.data.stats.minigamesPlayCount ?? 0) + 1;
    QuestEngine.recordEvent('minigames_played', GameState.data.stats.minigamesPlayCount);
    if (minigameId === 'rhythm' && score > (GameState.data.stats.minigameBest.rhythm ?? 0)) {
      QuestEngine.recordEvent('rhythm_game_score', score);
    } else if (minigameId === 'rhythm') {
      QuestEngine.recordEvent('rhythm_game_score', GameState.data.stats.minigameBest.rhythm ?? score);
    }

    const reward = this.rewardFor(score);
    EconomyEngine.grant(reward);
    EventBus.emit('minigame-completed', { minigameId, score, rewards: reward });

    // Emit fly animation events for currency gain
    if (fromX !== undefined && fromY !== undefined) {
      if (reward.stars > 0) {
        EventBus.emit('currency-fly', { type: 'stars', amount: reward.stars, fromX, fromY });
      }
      if (reward.coins > 0) {
        // Slight delay so they don't overlap exactly
        setTimeout(() => {
          EventBus.emit('currency-fly', { type: 'coins', amount: reward.coins, fromX, fromY: (fromY ?? 0) + 20 });
        }, 300);
      }
    }

    GameState.persist();
    return reward;
  },
};
